export default [{
    path: '/user/brand/index',
    name: '品牌首页',
    component: function (resolve) {
      require(['@/pages/userPage/brand/index'], resolve)
    }
  },

  {
    path: '/brand/dynamic/manage',
    name: '动态管理',
    component: function (resolve) {
      require(['@/pages/userPage/brand/dynamic-manage'], resolve)
    }
  },
  {
    path: '/brand/wx/setting',
    name: '公众号设置',
    component: function (resolve) {
      require(['@/pages/userPage/brand/wx-setting'], resolve)
    }
  },
  {
    path: '/brand/wx/redpackets/setting',
    name: '红包管理',
    component: function (resolve) {
      require(['@/pages/userPage/brand/wx-redpackets-setting'], resolve)
    }
  },
  {
    path: '/brand/xcx/list',
    name: '小程序列表',
    component: function (resolve) {
      require(['@/pages/userPage/brand/wx-xcx-list'], resolve)
    }
  },
  {
    path: '/brand/apply/xcx',
    name: '申请小程序',
    component: function (resolve) {
      require(['@/pages/userPage/brand/wx-apply-xcx'], resolve)
    }
  },
  {
    path: '/xcx/edit',
    name: '申请小程序',
    component: function (resolve) {
      require(['@/pages/userPage/brand/xcx-edit'], resolve)
    }
  },
  {
    path: '/public/brand',
    name: '公共品牌',
    component: function (resolve) {
      require(['@/pages/userPage/brand/public-brand'], resolve)
    }
  },
  {
    path: '/wx/sucess',
    name: '公共品牌',
    component: function (resolve) {
      require(['@/pages/userPage/brand/wx-sucess'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/userLayout/brand.js